





































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import {
  companyList,
  scheduleListByCompanyId,
  deleteCompanySchedule,
  submitSources,
} from "@/serve/medicalAppointment/plan";
import { Calendar } from "element-ui";

@Component({
  name: "companyManage",
  components: { Calendar },
})
export default class MedicalReport extends Vue {
  public isSetting = false;
  public tableHeaderStyle = {
    fontSize: "14px",
    background: "#fafafa",
    color: "black",
  };
  public selectedBatch: any = [];
  public batchInputValue: any = 0;
  public selectAllData: any = false;
  public selectedDates: any = [];
  public sources: any = [];
  public form = {
    name: "",
    current: 1,
    size: 10,
  };
  public pagination = {
    siez: 0,
    total: 0,
    current: 0,
  };
  public tableData = [
    {
      id: 1,
      name: "",
    },
  ];
  public companyId = 0;
  public companyName = "";

  public created() {
    this.getReportList();
  }

  public remainAlloc(item: any) {
    return item.daySurPlus - item.companyNum;
  }

  public handleRadioChange(index: any) {
    const idx = this.selectedBatch.indexOf(index);
    if (idx !== -1) {
      this.selectAllData = false;
      this.selectedBatch.splice(idx, 1);
    } else {
      this.selectedBatch.push(index);
    }
    this.updateBatchInputToSelected();
  }

  public selectAll() {
    if (this.selectAllData) {
      this.selectedBatch = [];
      for (let i = 0; i < this.selectedDates.length; i++) {
        this.selectedBatch.push(i);
        this.selectedDates[i].isSelected = true;
      }
    } else {
      this.selectedBatch = [];
      this.selectedDates.forEach((item: any) => {
        item.isSelected = false;
      });
    }
  }

  public updateBatchInputToSelected() {
    const inputValue = parseInt(this.batchInputValue, 10);
    if (!isNaN(inputValue)) {
      this.selectedDates.forEach((item: any, index: any) => {
        if (this.selectedBatch.includes(index)) {
          item.companyNum = inputValue;
        }
      });
    }
  }

  public onBatchInput(e: any) {
    const inputValue = parseInt(e, 10) || 0;
    if (e <= 0) {
      this.batchInputValue = 0;
    } else {
      this.batchInputValue = inputValue;
    }
    this.updateBatchInputToSelected();
  }

  public handleDateSelect() {
    return;
  }

  public toggleDateSelection(date: any) {
    const formattedDate: any = this.formatDate(date);
    const source = this.sources.find((s: any) => s.date === formattedDate);
    const selectedData = {
      date: formattedDate,
      daySurPlus: source ? source.daySurPlus : 0,
      companyNum: source ? source.companyNum : 0,
      scheduleId: source ? source.scheduleId : 0,
      periodList: source && source.periodList.length ? source.periodList : [],
    };
    if (!this.isDateAvailable(date)) {
      this.$message("当日没有可选号源");
      return;
    }
    const index = this.selectedDates.findIndex(
      (d: any) => d.date === formattedDate
    );
    if (index !== -1) {
      this.selectedDates.splice(index, 1);
    } else {
      this.selectedDates.push(selectedData);
    }
  }

  public unselectDate(index: number) {
    this.selectedDates.splice(index, 1);
    this.selectedBatch = this.selectedBatch.filter((i: number) => i !== index);
  }

  public clearSelected() {
    this.selectedDates = [];
    this.selectedBatch = [];
    this.selectAllData = false;
    this.batchInputValue = 0;
  }

  public isSelected(date: any) {
    const formattedDate = this.formatDate(date);
    return this.selectedDates.some((item: any) => item.date === formattedDate);
  }

  public getSourceNum(date: any) {
    const formattedDate = this.formatDate(date);
    const source = this.sources.find((s: any) => s.date === formattedDate);
    return source ? source.daySurPlus : 0;
  }

  public companyNum(date: any) {
    const formattedDate = this.formatDate(date);
    const source = this.sources.find((s: any) => s.date === formattedDate);
    return source ? source.companyNum : 0;
  }

  public isDateAvailable(date: any) {
    const formattedDate = this.formatDate(date);
    return this.sources.some((source: any) => source.date === formattedDate);
  }

  public formatDate(date: any) {
    return date.toISOString().split("T")[0];
  }

  public async getReportList() {
    companyList(this.form).then((res: any) => {
      this.tableData = res.records;
      this.pagination.siez = res.size;
      this.pagination.total = res.total;
      this.pagination.current = res.current;
    });
  }

  public onSubmit() {
    this.form.size = 10;
    this.form.current = 1;
    this.getReportList();
  }

  public reset() {
    this.form.current = 1;
    this.form.size = 10;
    this.form.name = "";
    this.getReportList();
  }

  public handleSizeChange(val: any): void {
    this.form.size = val;
    this.getReportList();
  }

  public handleCurrentChange(val: any): void {
    this.form.current = val;
    this.getReportList();
  }

  public submitData() {
    const params: any = {
      companyId: this.companyId,
      timeList: [],
    };
    for (let i = 0; i < this.selectedDates.length; i++) {
      const data: any = {
        scheduleId: this.selectedDates[i].scheduleId,
        number: parseInt(this.selectedDates[i].companyNum, 10),
        periodList: this.selectedDates[i].periodList.map((item: any) => ({
          ...item,
          pNumber: item.number,
        })),
      };
      params.timeList.push(data);
    }
    submitSources(params).then((res: any) => {
      if (res.code === 200) {
        this.$message({
          message: "提交成功",
          type: "success",
        });
        scheduleListByCompanyId(this.companyId).then((obj: any) => {
          this.sources = obj.data;
        });
        this.batchInputValue = 0;
        this.selectedDates = [];
        this.selectAllData = false;
        this.selectedBatch = [];
      }
    });
  }

  public remove() {
    this.companyId = 0;
    this.companyName = "";
    this.selectedDates = [];
    this.selectAllData = false;
    this.selectedBatch = [];
    this.batchInputValue = 0;
    this.getReportList();
  }

  public goBack() {
    this.isSetting = false;
    this.remove();
  }

  public deleteCompanySchedule(date: any) {
    const formattedDate: any = this.formatDate(date);
    const source = this.sources.find((s: any) => s.date === formattedDate);
    (this as any).$messageBox
      .confirm("您确定要删除号源吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        const params = {
          companyId: this.companyId,
          scheduleId: source.scheduleId,
        };
        deleteCompanySchedule(params).then((res: any) => {
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            scheduleListByCompanyId(this.companyId).then((obj: any) => {
              this.sources = obj.data;
            });
            this.selectedDates = [];
          }
        });
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除",
        });
      });
  }

  public changeSoure(data: any) {
    this.isSetting = true;
    this.companyId = data.companyId;
    this.companyName = data.companyName;
    this.clearSelected();
    scheduleListByCompanyId(data.companyId).then((res: any) => {
      this.sources = res.data;
    });
  }
}
